module.exports = __webpack_public_path__ + "static/blurred_smudge_2@2x-94000818ab789bfd76b4e17da6beaf5a.png";